import classnames from 'classnames'
import React, {useCallback, useRef} from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'

import styles from './Radio.module.css'
import {FieldValidator} from "final-form";
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';

interface IRadioProps {
  label: string
  name: string
  value: string
  optional?: boolean
  ariaDescription?: string
  disabled? : boolean,
  validate?: FieldValidator<string>,
  popoverBool?: boolean
}

export const Radio: React.FC<IRadioProps> = ({
  name,
  label,
  value,
  optional,
  popoverBool = false,
  ariaDescription,
  disabled = false,
  validate = undefined,

}) => {
  const popoverIznosMirovine = (
    <Popover id="popover-basic" className="popover-info">
      <Popover.Content>
        {<b>Molimo upisati iznos mirovine u formatu "XXXX.YY".<br/> Za upis decimalnog broja koristiti točku, a ne zarez.  (ukoliko je iznos mirovine 2100 kuna i 54 lipe, upisati 2100.54)</b>} {<br/>}
      </Popover.Content>
    </Popover>
  );

  const InfoIznosMirovine = () => (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popoverIznosMirovine}>
      <Button variant="popover-button"><i className="fa fa-question"></i></Button>
    </OverlayTrigger>
  );

  const requiredValidation = useCallback((value: string, _allValues: any) => {

    if (!optional && (value == null || value === '')) {
      return 'Required field'
    } else {
      return undefined
    }
  }, [optional])

  const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
    const validations: Array<FieldValidator<string>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
        message == null
            ? fn(value, allValues)
            : message
    ), undefined)
  })

  return (
    <Field
      name={name}
      type='radio'
      value={value}
      validate={validatorRef.current}
    >
      {({ input, meta }) => (
        <div className={classnames(styles.Radio, {
          'custom-control custom-radio': true,
          'is-invalid': meta.touched && meta.error,
        })}>
          <input
            id={`id-${name}-${value}`}
            name={input.name}
            type='radio'
            value={input.value}
            checked={input.checked}
            onChange={event => {
              document.querySelectorAll('input[name=' + event.target.name + ']')
                ?.forEach(element => (element as HTMLInputElement).setCustomValidity(""));
              input.onChange(event);
            }}
            onInvalid={event => (event.target as HTMLSelectElement).setCustomValidity('Molimo odabrati jednu od opcija.')}
            className='custom-control-input'
            required={optional ? '' : 'required' as any}
            aria-describedby={ariaDescription}
            disabled={disabled}
          />
          <label
            className={classnames('custom-control-label', styles.FixTextAlignment)}
            htmlFor={`id-${name}-${value}`}
          >
            { label }
          </label>
          {popoverBool && <InfoIznosMirovine />}
          { meta.touched && meta.error && <div className='invalid-feedback'>{meta.error}</div> }
          { ariaDescription && (
              <span
                  id={`help-${name}`}
                  className={classnames('form-text text-muted', styles.AriaDescriptionSpecial)}
              >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}